import { handleActions } from 'redux-actions';
import { defaultSettings } from 'widget/player-widget';

import globalSettings from 'shared/settings';

import { NAME as APP_SETTINGS_UPDATE } from 'widget/redux/client/actions/app-settings/update';
import DEFAULT_SETTINGS_V1 from 'shared/constants/default-settings-v1';

const initialSettings = {
  booleans: {},
  colors: {},
  fonts: {},
  numbers: {},
  requestedWidgetSize: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  ...globalSettings,
};

export default handleActions({
  [APP_SETTINGS_UPDATE]: (state, { payload }) => {
    const currentSettings = _.merge({}, state, payload);
    const isNewInstallation = !_.get(currentSettings, 'fonts.channelId');
    const isCurrentSettingsV1 = _.get(currentSettings, 'numbers.settingsVersion') === 1;

    return _.merge(
      {},
      initialSettings,
      isNewInstallation || isCurrentSettingsV1 ? DEFAULT_SETTINGS_V1 : defaultSettings,
      currentSettings,
    );
  },
}, null);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/app-settings.js